import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  help: {
    id: 'fabric.editor.elementBrowser.help',
    defaultMessage: 'Help',
    description: 'Element browser help button label'
  },
  all: {
    id: 'fabric.editor.elementbrowser.categorylist.category-all',
    defaultMessage: 'All',
    description: 'all'
  },
  formatting: {
    id: 'fabric.editor.elementbrowser.categorylist.category-formatting',
    defaultMessage: 'Formatting',
    description: 'formatting'
  },
  'confluence-content': {
    id: 'fabric.editor.elementbrowser.categorylist.category-confluence-content',
    defaultMessage: 'Confluence content',
    description: 'confluence-content'
  },
  media: {
    id: 'fabric.editor.elementbrowser.categorylist.category-media',
    defaultMessage: 'Media',
    description: 'media'
  },
  visuals: {
    id: 'fabric.editor.elementbrowser.categorylist.category-visuals',
    defaultMessage: 'Visuals & images',
    description: 'visuals'
  },
  navigation: {
    id: 'fabric.editor.elementbrowser.categorylist.category-navigation',
    defaultMessage: 'Navigation',
    description: 'navigation'
  },
  'external-content': {
    id: 'fabric.editor.elementbrowser.categorylist.category-external-content',
    defaultMessage: 'External content',
    description: 'external-content'
  },
  communication: {
    id: 'fabric.editor.elementbrowser.categorylist.category-communication',
    defaultMessage: 'Communication',
    description: 'communication'
  },
  reporting: {
    id: 'fabric.editor.elementbrowser.categorylist.category-reporting',
    defaultMessage: 'Reporting',
    description: 'reporting'
  },
  admin: {
    id: 'fabric.editor.elementbrowser.categorylist.category-admin',
    defaultMessage: 'Administration',
    description: 'admin'
  },
  development: {
    id: 'fabric.editor.elementbrowser.categorylist.category-development',
    defaultMessage: 'Development',
    description: 'development'
  },
  AI: {
    id: 'fabric.editor.elementbrowser.categorylist.category-ai',
    defaultMessage: 'Atlassian Intelligence',
    description: 'AI'
  },
  featuredWhiteboardDescription: {
    id: 'fabric.editor.elementbrowser.featured.whiteboard.description',
    defaultMessage: 'Use a whiteboard to add visuals to your page',
    description: 'Displayed as the description for a featured whiteboard insert action'
  }
});